import { css } from '@emotion/react';
import { DesignToken, ShadowToken, SpacingToken } from '@livechat/design-system-react-components';
import { MEDIA_MIN_XSS } from '_assets/css/breakpoints';

export const loaderContainer = css`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;

export const mainContainer = (isPageOverflowing: boolean) => css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  margin: auto;
  padding: 48px;
  max-width: 696px;

  > form {
    width: 100%;
  }

  ${isPageOverflowing &&
  css`
    padding-bottom: 100px;
  `}
`;

export const header = css`
  max-width: 460px;
  font-weight: 600;
`;

export const consentNote = css`
  margin-top: var(${SpacingToken.Spacing7});
  margin-bottom: var(${SpacingToken.Spacing3});
  width: 100%;
  text-align: left;
`;

export const accordionContainer = css`
  display: flex;
  flex-direction: column;
  gap: var(${SpacingToken.Spacing3});
`;

export const accordion = css`
  &[aria-expanded='false'] {
    > div > div {
      display: contents;

      > div {
        position: inherit;
      }
    }
  }
`;

export const accordionConent = css`
  display: flex;
  flex-direction: column;
`;

export const iconAndLabel = css`
  display: flex;
  flex-direction: row;
  gap: var(${SpacingToken.Spacing2});
`;

export const scopeGroups = `
  display: flex;
  flex-direction: column;
  gap: var(${SpacingToken.Spacing5});
`;

export const scopeGroupNames = css`
  padding-left: var(${SpacingToken.Spacing8});
  color: var(${DesignToken.ContentBasicSecondary});
  text-align: left;
`;

export const scopesGroupsDetails = css`
  padding-left: var(${SpacingToken.Spacing8});
  text-align: left;
  flex-direction: column;
  gap: var(${SpacingToken.Spacing3});
  display: flex;
`;

export const singleGroupDetails = css`
  display: flex;
  flex-direction: row;
`;

export const singleGroupName = css`
  text-align: left;
  min-width: 120px;
  max-width: 120px;

  ${MEDIA_MIN_XSS} {
    min-width: 156px;
    max-width: 156px;
  }
`;

export const scopesList = css`
  display: flex;
  flex-direction: column;
  text-align: left;
`;

export const scopeName = css`
  color: var(${DesignToken.ContentBasicSecondary});
`;

export const buttonsContainer = (isPageOverflowing: boolean) => css`
  margin-top: var(${SpacingToken.Spacing7});
  margin-bottom: -12px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: var(${SpacingToken.Spacing2});

  ${isPageOverflowing &&
  css`
    margin: 0;
    width: 100%;
    background-color: var(${DesignToken.SurfacePrimaryDefault});
    padding: var(${SpacingToken.Spacing5}) 0;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    box-shadow: var(${ShadowToken.PopOver});
    z-index: 10;
  `}
`;

export const goBackButton = css`
  margin: 0;
`;
